export const PORTAL_FULL_MIN_WIDTH = 617;
export const PORTAL_MID_MIN_WIDTH = 456;